import React from "react";
import { Container, Row, Col } from "reactstrap";
// import {} from "bootstrap"

const Footer = () => {
  return (
    <div className="com">
      <Row className="bg-secondary fixed-bottom">
        <Col lg={12} className="text-center">
          <p>
            Created By{" "}
            <a
              href="https://www.linkedin.com/in/shrey-vasani-254019159"
              target="_blank"
              className="text-white"
            >
              Shrey Vasani
            </a>{" "}
            By Using{" "}
            <a href="https://www.pexels.com/" target="_blank" className="text-white">
              Pexels Api
            </a>
          </p>
        </Col>
      </Row>
    </div>
  );
};
export default Footer;
